import React from "react";

import { queryClient } from '../../state/queryClient';
import { usePostmarkmails } from "../../state/reactquery";



import './EcranPostmark.scss' ;
function EcranPostmark(){

    const {data: emails} = usePostmarkmails() ; 

    const actualiser = ()=>{
        queryClient.invalidateQueries({ queryKey: ['postmarkmails']})  ;
    }
       
    function extraireEmail(texte){ if (!texte || typeof texte !== 'string') {   return null; }
        const regexEmail = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
        const match = texte.match(regexEmail);
        return match ? match[0] : null;
    }


    return(<div  className="ecranparametres" >
             <div className="ecranparametrestop_titre"  >Postmark - Emails Envoyés  <span onClick={actualiser}></span></div>
             <table className="tablepostmark">
                  <thead>
                        <tr>
                            <th >Date</th><th >De</th><th >A</th><th >Objet</th><th >Statut</th>
                        </tr>
                  </thead>
                  <tbody>
                    {emails?.length>0 && emails.map(x=><tr  key={x.MessageID}  >
                                                             <td >{(new Date(x.ReceivedAt)).toLocaleString("fr-FR", {timeZone: "Europe/Paris" ,dateStyle: "short",   timeStyle: "short"}) }</td>
                                                             <td >{extraireEmail(x.From)}</td>
                                                             <td >{x.Recipients?.join(' - ')}</td>
                                                             <td >{x.Subject}</td>
                                                             <td >{x.Status}</td>
                                                    </tr>)
                    }
                  </tbody>


            </table>
    </div>)
}

export default EcranPostmark